class Menu {
    constructor() {
        this.$burgerButton = $('#burger-button');
        this.$menuOpenIcon = $('#menu-open');
        this.$menuCloseIcon = $('#menu-close');
        this.$menuContainer = $('.menu-container');
        this.$menuItemsWithChildren = $('.menu-item-has-children');
        this.$allMenuItems = $('.menu-container a');
        this.isMenuOpen = false;
        this.isMobile = window.matchMedia('(max-width: 767px)').matches;
        
        this.init();
        this.initMenuTabIndexes();
        this.initKeyboardHandlers();
        this.initResizeHandler();
    }

    init() {
        // Toggle menu on burger click
        this.$burgerButton.on('click', (e) => {
            e.preventDefault();
            
            // If close icon is clicked and submenus are open, close only submenus
            if ($(e.target).is('#menu-close') && this.$menuItemsWithChildren.hasClass('open')) {
                this.closeAllSubmenus();
                return;
            }
            
            this.toggleMenu();
        });

        // Handle submenu toggles
        this.$menuItemsWithChildren.each((_, item) => {
            const $item = $(item);
            const $link = $item.children('a');
            const $submenu = $item.children('ul.sub-menu');

            // Handle click events
            $link.on('click', (e) => {
                e.preventDefault();
                this.toggleSubmenu($item);
            });

            // Handle keyboard events
            $link.on('keydown', (e) => {
                switch(e.key) {
                    case 'Enter':
                    case ' ':
                        e.preventDefault();
                        this.toggleSubmenu($item);
                        break;
                    case 'ArrowDown':
                        e.preventDefault();
                        if ($item.hasClass('open')) {
                            $submenu.find('a').first().focus();
                        }
                        break;
                }
            });

            // Handle ESC key in submenus
            const $subItems = $item.find('ul.sub-menu a');
            $subItems.on('keydown', (e) => {
                switch(e.key) {
                    case 'Escape':
                        e.preventDefault();
                        this.closeSubmenu($item);
                        $link.focus();
                        break;
                    case 'ArrowUp':
                        if ($(e.target).is($submenu.find('a').first())) {
                            e.preventDefault();
                            $link.focus();
                        }
                        break;
                }
            });
        });

        // Close menu when clicking outside on mobile
        $(document).on('click', (e) => {
            if (this.isMobile && 
                !$(e.target).closest('.menu-container').length && 
                !$(e.target).closest('#burger-button').length && 
                this.isMenuOpen) {
                this.closeMenu();
            }
        });
    }

    initResizeHandler() {
        let resizeTimeout;
        $(window).on('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                const wasMobile = this.isMobile;
                this.isMobile = window.matchMedia('(max-width: 767px)').matches;
                
                // Only update if the breakpoint changed
                if (wasMobile !== this.isMobile) {
                    this.updateMenuState();
                }
            }, 250);
        });
    }

    updateMenuState() {
        if (!this.isMobile) {
            // On desktop, menu is always visible
            this.$menuContainer.removeClass('translate-x-full translate-x-0');
            this.initMenuTabIndexes();
            $('body').removeClass('overflow-hidden');
        } else {
            // On mobile, restore the closed state
            if (!this.isMenuOpen) {
                this.$menuContainer.addClass('translate-x-full').removeClass('translate-x-0');
                this.initMenuTabIndexes();
            }
        }
    }

    initMenuTabIndexes() {
        if (this.isMobile) {
            // On mobile, tabindex depends on menu state
            this.$allMenuItems.attr('tabindex', -1);
            if (this.isMenuOpen) {
                this.$menuContainer.children('ul').children('li').children('a').attr('tabindex', 0);
            }
        } else {
            // On desktop, all top-level items are focusable
            this.$menuContainer.children('ul').children('li').children('a').attr('tabindex', 0);
            // Submenu items start as not focusable until their parent is opened
            this.$menuItemsWithChildren.each((_, item) => {
                $(item).find('ul.sub-menu a').attr('tabindex', -1);
            });
        }
    }

    initKeyboardHandlers() {
        // Handle ESC key for main menu
        $(document).on('keydown', (e) => {
            if (e.key === 'Escape') {
                if (this.isMobile && this.isMenuOpen) {
                    // On mobile, ESC closes the main menu if no submenu is open
                    if (!$(e.target).closest('.sub-menu').length) {
                        this.closeMenu();
                    }
                } else {
                    // On desktop, ESC only closes submenus
                    const $openSubmenu = $('.menu-item-has-children.open');
                    if ($openSubmenu.length) {
                        this.closeSubmenu($openSubmenu);
                        $openSubmenu.children('a').focus();
                    }
                }
            }
        });

        // Handle keyboard events on burger button
        this.$burgerButton.on('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this.toggleMenu();
            }
        });
    }

    toggleMenu() {
        this.isMenuOpen ? this.closeMenu() : this.openMenu();
    }

    openMenu() {
        if (!this.isMobile) return;
        
        this.isMenuOpen = true;
        this.$menuContainer.removeClass('translate-x-full').addClass('translate-x-0');
        this.$menuOpenIcon.addClass('hidden').removeClass('inline-block');
        this.$menuCloseIcon.removeClass('hidden').addClass('inline-block');
        this.$burgerButton.attr('aria-expanded', 'true');
        $('body').addClass('overflow-hidden');
        
        this.initMenuTabIndexes();
        
        // Focus the first menu item
        this.$menuContainer.find('a[tabindex="0"]').first().focus();
    }

    closeMenu() {
        if (!this.isMobile) return;
        
        this.isMenuOpen = false;
        this.$menuContainer.removeClass('translate-x-0').addClass('translate-x-full');
        this.$menuOpenIcon.addClass('inline-block').removeClass('hidden');
        this.$menuCloseIcon.addClass('hidden').removeClass('inline-block');
        this.$burgerButton.attr('aria-expanded', 'false');
        $('body').removeClass('overflow-hidden');
        
        // Close all open submenus
        this.closeAllSubmenus();
        
        this.initMenuTabIndexes();
        
        // Return focus to the burger button
        this.$burgerButton.focus();
    }

    closeAllSubmenus() {
        this.$menuItemsWithChildren.each((_, item) => {
            this.closeSubmenu($(item));
        });
    }

    closeSubmenu($menuItem) {
        if ($menuItem.hasClass('open')) {
            $menuItem.removeClass('open');
            const $subItems = $menuItem.find('ul.sub-menu a');
            $subItems.attr('tabindex', -1);
            
            // Update close icon brightness after closing submenu
            this.updateCloseIconBrightness();
        }
    }

    toggleSubmenu($menuItem) {
        const isOpen = $menuItem.hasClass('open');
        
        // Close other open submenus at the same level
        $menuItem.siblings('.open').each((_, item) => {
            this.closeSubmenu($(item));
        });
        
        // Toggle current submenu
        $menuItem.toggleClass('open');
        
        // Update tabindex for submenu items
        const $subItems = $menuItem.find('ul.sub-menu a');
        $subItems.attr('tabindex', !isOpen ? 0 : -1);
        
        // Update close icon brightness based on submenu state
        this.updateCloseIconBrightness();
        
        // If opening, focus the first submenu item
        if (!isOpen) {
            $subItems.first().focus();
        }
    }

    updateCloseIconBrightness() {
        // Check if any submenu is open
        const hasOpenSubmenu = this.$menuItemsWithChildren.hasClass('open');
        this.$menuCloseIcon.toggleClass('brightness-0', hasOpenSubmenu);
    }
}

new Menu();